var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "toaster" },
    [
      _c(
        "transition-group",
        { attrs: { name: "toaster-transition" } },
        _vm._l(_vm.notifications, function(notification) {
          return _c("vs-toast", {
            key: notification,
            attrs: { notification: notification },
            on: {
              "remove-toast": function($event) {
                return _vm.$emit("remove-toast", $event)
              }
            }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }